import { safeDefine } from "../../registration/safe-define.js";
import { CastButtonElement } from "../../ui/cast-button/element.js";
//#region src/define/ui/cast-button.ts
safeDefine(CastButtonElement);
//#endregion

//# sourceMappingURL=cast-button.js.map